import { PRESENCIALES_HOME_RECEIVED } from "../types";

const HomeReducer = (state, { type, payload }) => {
  switch (type) {
    case PRESENCIALES_HOME_RECEIVED:
      return { ...state, presenciales: payload };
    default:
      return { ...state };
  }
};

export default HomeReducer;
